import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';
import classnames from 'classnames';

import {
  FontWeight,
  Heading as HeadingComponent,
  HeadingKindType,
  HeadingLevelType,
  useBreakpoint
} from '@savebetter/components';

import { useBankProducts } from '../context/BankProductsContext';
import { replaceCustomVars } from '../utils/replaceCustomVar';

import { Section } from './Section';

interface Blok extends SbBlokData {
  kind: HeadingKindType;
  text: string;
  level?: HeadingLevelType;
  className?: string;
  color?: string;
  hasBackground?: boolean;
  textAlignment?: string;
  backgroundColor?: string;
  fontWeight?: FontWeight;
}
interface HeadingProps {
  blok: Blok;
}

const sectionClass = {
  sm: 'sb-section-sm',
  md: 'sb-section-md',
  lg: 'sb-section-lg'
};

export const Heading: FunctionComponent<HeadingProps> = ({ blok }) => {
  const { contextProducts } = useBankProducts();
  const {
    kind,
    level,
    text,
    color: textColor,
    textAlignment,
    className,
    hasPaddingBottom,
    hasPaddingTop,
    hasBackground,
    backgroundColor = '',
    fontWeight
  } = blok;

  const breakpoint = useBreakpoint();
  const id = text?.toLowerCase().replace(/\W/g, '_');

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      blok={blok}
      className={classnames({
        [backgroundColor]: !hasBackground
      })}
    >
      <div
        {...storyblokEditable(blok)}
        className={classnames(`sb-section ${sectionClass[breakpoint]}`, {
          'pb-4': !hasPaddingBottom && className && !className.includes('py-0'),
          'pt-4': !hasPaddingTop && className && !className.includes('py-0'),
          'pb-12': hasPaddingBottom,
          'pt-12': hasPaddingTop
        })}
      >
        <div className={classnames(`${textAlignment || 'text-center'} w-full`, className)}>
          <HeadingComponent
            id={id}
            kind={kind}
            level={level}
            className={classnames(className, textColor)}
            fontWeight={fontWeight}
          >
            {replaceCustomVars(text, contextProducts)}
          </HeadingComponent>
        </div>
      </div>
    </Section>
  );
};
